var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{ref:"modal",attrs:{"name":"members","title":"Membros","size":"small"},on:{"open":_vm.onOpenModal}},[_c('section',[_c('SearchMember',{on:{"selected":_vm.onSelected}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }